import {
	RETIREMENT_ANCHOR_KEYS,
	RETIREMENT_ANCHOR_RATIOS,
	RETIREMENT_FIXED_ANCHORS,
	RETIREMENT_INCOME_MIN,
	RETIREMENT_INCOME_STEP,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementAnchor } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const roundToStep = (value: number, step: number): number =>
	Math.round(value / step) * step;

export const getRetirementAnchors = (
	retirementExpenses: number | undefined,
	incomeMax: number,
): RetirementAnchor[] => {
	if (retirementExpenses === undefined)
		return RETIREMENT_ANCHOR_KEYS.map((key) => ({
			key,
			amount: RETIREMENT_FIXED_ANCHORS[key],
		}));

	const seen = new Set<number>();

	return RETIREMENT_ANCHOR_KEYS.flatMap((key) => {
		const ratio = RETIREMENT_ANCHOR_RATIOS[key];
		const raw =
			ratio === 1
				? retirementExpenses
				: roundToStep(retirementExpenses * ratio, RETIREMENT_INCOME_STEP);
		const amount = Math.min(incomeMax, Math.max(RETIREMENT_INCOME_MIN, raw));
		if (seen.has(amount)) return [];
		seen.add(amount);
		return [{ key, amount }];
	});
};
